/* Tuotelista frontend (Dimex) — VERSIO: sertifikaatit + tuotekohtaiset tarkenteet + €-suffix hintamerkintään
   ----------------------------------------------------------------------------------------------------------------
   - Käännökset: getI18n hakee järjestyksessä:
       1) data-i18n[key]
       2) data-i18n.tuotelista[key]
       3) data-i18n.tuotelista_ui[key]
       4) sisäänrakennettu fallback (FI/EN/DE/ET)
   - Sertifikaatit: product.metafields.global.standardit -> listataan ja liitetään tarkenne metatietokentistä (en_*).
   - Hintamerkintä: kentässä pysyvä €-suffix (UI), PDF:lle näytettävässä tekstissä lisätään “ €”, ellei käyttäjä ole jo
     kirjoittanut valuuttamerkkiä/valuuttakoodia. Raaka-arvo tallennetaan stateen (priceTextRaw).
*/
(function () {
  const LS_KEY = "tuotelista_state_v1";

  document.addEventListener("DOMContentLoaded", () => {
    let sectionEl =
      document.querySelector("section.tuotelista") ||
      document.querySelector('[data-section-type="tuotelista"]') ||
      document.querySelector('section[data-section-id].tuotelista');

    if (!sectionEl) {
      console.warn("[Tuotelista] Sectioniä ei löytynyt – luodaan väliaikainen kontti (kehitystä varten).");
      sectionEl = document.createElement("section");
      sectionEl.className = "tuotelista";
      document.body.appendChild(sectionEl);
    }

    const sectionId = sectionEl.dataset.sectionId || "tuotelista";
    const cfgFromGlobal = (window.TUOTELISTA_SECTION || {})[sectionId] || {};
    const cfg = {
      token: (sectionEl.dataset.storefrontAccessToken || cfgFromGlobal.token || "").trim(),
      shop: (sectionEl.dataset.shopDomain || cfgFromGlobal.shop || "").trim(),
      locale: (sectionEl.dataset.locale || cfgFromGlobal.locale || "fi").trim(),
      colorOptionNamesCSV: sectionEl.dataset.colorOptionNames || cfgFromGlobal.colorOptionNamesCSV || "Väri,Color",
      sizeOptionNamesCSV: sectionEl.dataset.sizeOptionNames || cfgFromGlobal.sizeOptionNamesCSV || "Koko,Size",
      taxesIncluded: sectionEl.dataset.taxesIncluded === "true"
    };

    console.log("[Tuotelista] cfg", {
      shop: cfg.shop,
      tokenPresent: !!cfg.token,
      locale: cfg.locale,
      taxesIncluded: cfg.taxesIncluded
    });

    init(sectionEl, cfg);
  });

  function init(sectionEl, cfg) {
    // --- Render-kontti ---
    let productsContainer = sectionEl.querySelector("#tpl-products");
    if (!productsContainer) {
      console.warn("[Tuotelista] #tpl-products puuttuu – luodaan automaattisesti.");
      productsContainer = document.createElement("div");
      productsContainer.id = "tpl-products";
      sectionEl.appendChild(productsContainer);
    }

    // Toiminnot
    const btnDownload = sectionEl.querySelector("#tpl-download");
    const btnClear = sectionEl.querySelector("#tpl-clear");
    const btnRemovedToggle = sectionEl.querySelector("#tpl-removed-toggle");

    // Poistetut-paneeli
    const removedPanel = document.getElementById("tpl-removed-panel");
    const removedList  = document.getElementById("tpl-removed-list");
    const btnRemovedClose = removedPanel?.querySelector(".tpl-removed-close");
    const btnRemovedRestoreAll = document.getElementById("tpl-removed-restore-all");

    // Snackbar
    const snackbar = document.getElementById("tpl-snackbar");

    // Lomake-elementit
    const fTitle  = document.getElementById("f-title");
    const fCName  = document.getElementById("f-c-name");
    const fCAddr  = document.getElementById("f-c-addr");
    const fCTel   = document.getElementById("f-c-tel");
    const fCEmail = document.getElementById("f-c-email");
    const fCWWW   = document.getElementById("f-c-www");
    const fVat255 = document.getElementById("f-vat255");

    const coverTitleEl = document.getElementById("cover-customtitle");
    const backCompanyEl = document.getElementById("back-company");

    ensurePrintOnlyHideStyle();
    ensureSuffixStyles(); // <-- UI-tyyli €-suffixille

    // ----- I18N: data-i18n + fallbackit -----
    const RAW_I18N = (() => {
      const raw = sectionEl.getAttribute("data-i18n") || "{}";
      try { const obj = JSON.parse(raw); return (obj && typeof obj === "object") ? obj : {}; }
      catch (e) { console.warn("[Tuotelista] data-i18n JSON parse failed:", e, raw); return {}; }
    })();

    const LOCALE_TAG = normalizeLocale(cfg.locale);

    const FALLBACK_I18N = {
      fi: { description:"Kuvaus", certificates:"Sertifikaatit", colors:"Värit", sizes:"Koot", materials:"Materiaalit",
            additional:"Lisätietoja", removed:"Poistetut", restore:"Palauta", restore_all:"Palauta kaikki", undo:"Kumoa",
            no_removed:"Ei poistettuja tuotteita.", confirm_clear_list:"Tyhjennetäänkö tämä tuotelista? (Ei muuta ostoskoria)",
            cleared_all:"Kaikki tuotteet poistettiin listalta.", empty_cart:"Ostoskorisi on tyhjä. Lisää tuotteita ja palaa tälle sivulle.",
            load_failed:"Tietojen lataus epäonnistui.", notes_label:"Tuotemuistiinpanot", notes_title:"Tuotemuistiinpanot",
            notes_placeholder:"Lisää muistiinpano (näkyy tuotetietojen alla)", hide_notes_in_pdf:"Piilota muistiinpanot PDF:stä",
            price_mark_label:"Hintamerkintä", price_mark_placeholder:"esim. 39,90", hide_price_in_pdf:"Piilota hinta PDF:stä",
            remove_from_list:"Poista tuote listalta", removed_item:"Tuote poistettiin listalta.", vat255:"(sis. ALV 25,5 %)",
            vat0:"(ALV 0 %)" },
      en: { description:"Description", certificates:"Certificates", colors:"Colors", sizes:"Sizes", materials:"Materials",
            additional:"Additional information", removed:"Removed", restore:"Restore", restore_all:"Restore all", undo:"Undo",
            no_removed:"No removed products.", confirm_clear_list:"Clear this product list? (Won’t change the cart)",
            cleared_all:"All products were removed from the list.", empty_cart:"Your cart is empty. Add products and return to this page.",
            load_failed:"Failed to load data.", notes_label:"Product notes", notes_title:"Product notes",
            notes_placeholder:"Add any notes (shown below product details)", hide_notes_in_pdf:"Hide notes in PDF",
            price_mark_label:"Price note", price_mark_placeholder:"e.g. 39.90", hide_price_in_pdf:"Hide price in PDF",
            remove_from_list:"Remove this product from the list", removed_item:"Product was removed from the list.",
            vat255:"(incl. VAT 25.5%)", vat0:"(VAT 0%)" },
      de: { description:"Beschreibung", certificates:"Zertifikate", colors:"Farben", sizes:"Größen", materials:"Materialien",
            additional:"Zusätzliche Informationen", removed:"Entfernt", restore:"Wiederherstellen", restore_all:"Alle wiederherstellen",
            undo:"Rückgängig", no_removed:"Keine entfernten Produkte.", confirm_clear_list:"Diese Produktliste leeren? (Warenkorb bleibt unverändert)",
            cleared_all:"Alle Produkte wurden aus der Liste entfernt.", empty_cart:"Dein Warenkorb ist leer. Füge Produkte hinzu und kehre zurück.",
            load_failed:"Daten konnten nicht geladen werden.", notes_label:"Produktnotizen", notes_title:"Produktnotizen",
            notes_placeholder:"Notizen hinzufügen (unter Produktdetails sichtbar)", hide_notes_in_pdf:"Notizen im PDF ausblenden",
            price_mark_label:"Preisnotiz", price_mark_placeholder:"z. B. 39,90", hide_price_in_pdf:"Preis im PDF ausblenden",
            remove_from_list:"Produkt aus der Liste entfernen", removed_item:"Produkt wurde aus der Liste entfernt.",
            vat255:"(inkl. MwSt. 25,5 %)", vat0:"(MwSt. 0 %)" },
      et: { description:"Kirjeldus", certificates:"Sertifikaadid", colors:"Värvid", sizes:"Suurused", materials:"Materjalid",
            additional:"Lisainfo", removed:"Eemaldatud", restore:"Taasta", restore_all:"Taasta kõik", undo:"Võta tagasi",
            no_removed:"Eemaldatud tooteid pole.", confirm_clear_list:"Kas puhastada see tooteloend? (Ostukorvi ei muudeta)",
            cleared_all:"Kõik tooted eemaldati loendist.", empty_cart:"Teie ostukorv on tühi. Lisage tooteid ja naaske siia.",
            load_failed:"Andmete laadimine ebaõnnestus.", notes_label:"Tootemärkmed", notes_title:"Tootemärkmed",
            notes_placeholder:"Lisa märkus (kuvatakse tooteinfo all)", hide_notes_in_pdf:"Peida märkmed PDF-is",
            price_mark_label:"Hinnamärkus", price_mark_placeholder:"nt 39.90", hide_price_in_pdf:"Peida hind PDF-is",
            remove_from_list:"Eemalda toode loendist", removed_item:"Toode eemaldati loendist.",
            vat255:"(sis. KM 25,5%)", vat0:"(KM 0%)" }
    };

    function getI18n(key, fallback = "") {
      let v = valueIfString(RAW_I18N[key]); if (v) return v;
      v = valueIfString(RAW_I18N.tuotelista?.[key]); if (v) return v;
      v = valueIfString(RAW_I18N.tuotelista_ui?.[key]); if (v) return v;
      v = valueIfString(FALLBACK_I18N[LOCALE_TAG]?.[key]); if (v) return v;

      if (!(
        Object.prototype.hasOwnProperty.call(RAW_I18N, key) ||
        Object.prototype.hasOwnProperty.call(RAW_I18N.tuotelista || {}, key) ||
        Object.prototype.hasOwnProperty.call(RAW_I18N.tuotelista_ui || {}, key)
      )) {
        console.warn("[Tuotelista] missing i18n key:", key);
      }
      return fallback;
    }
    function valueIfString(x){ return (typeof x === "string" && x.trim() !== "") ? x : ""; }
    function normalizeLocale(locale) {
      const lc = String(locale || "").toLowerCase();
      if (lc.startsWith("fi")) return "fi";
      if (lc.startsWith("de")) return "de";
      if (lc.startsWith("et")) return "et";
      return "en";
    }

    // ----- Tila -----
    let state = loadState() || { form: {}, products: {}, removed: {} };
    let cartPidSet = new Set();

    // Täytä lomake aiemmasta tilasta
    if (fTitle)  fTitle.value  = state.form.title  || "";
    if (fCName)  fCName.value  = state.form.cname  || "";
    if (fCAddr)  fCAddr.value  = state.form.caddr  || "";
    if (fCTel)   fCTel.value   = state.form.ctel   || "";
    if (fCEmail) fCEmail.value = state.form.cemail || "";
    if (fCWWW)   fCWWW.value   = state.form.cwww   || "";
    if (fVat255) fVat255.checked = !!state.form.vat255;

    applyCoverAndBack();
    updateRemovedUI();
    updateClearVisibility();

    // ----- Apurit -----
    const COLOR_NAMES = (cfg.colorOptionNamesCSV || "Väri,Color").split(",").map(s => s.trim().toLowerCase());
    const SIZE_NAMES  = (cfg.sizeOptionNamesCSV  || "Koko,Size").split(",").map(s => s.trim().toLowerCase());

    // Raha: muotoilu – symboli oikealla
    const money = (amount, currency) => formatMoneyRight(amount, currency, cfg.locale || "fi-FI");

    const byOptionName = (options, wanted) => {
      const res = [];
      (options || []).forEach((opt) => {
        if (wanted.includes((opt.name || "").toLowerCase())) {
          (opt.values || []).forEach((v) => { if (!res.includes(v)) res.push(v); });
        }
      });
      return res;
    };

    const sizesFromVariants = (variants, wanted) => {
      const set = new Set();
      (variants || []).forEach((v) => {
        (v.selectedOptions || []).forEach((so) => {
          if (wanted.includes((so.name || "").toLowerCase())) set.add(so.value);
        });
      });
      return Array.from(set);
    };

    const imageUrl = (url, width = 1400) => {
      try { const u = new URL(url); u.searchParams.set("width", String(width)); return u.toString(); }
      catch { return url; }
    };

    // --- PRINTTIIN KEVENNETYT KUVAT (Shopify CDN -parametrit, kevyt fallback) ---
    function addCdnParams(url, { width, format = 'pjpg', quality = 70 } = {}) {
      try {
        const u = new URL(url);
        if (width)   u.searchParams.set('width', String(width));
        if (format)  u.searchParams.set('format', format);
        if (quality) u.searchParams.set('quality', String(quality));
        return u.toString();
      } catch {
        return url;
      }
    }
    function preparePrintImages() {
      document.querySelectorAll('.tpl-product__media img').forEach(img => {
        const orig = img.getAttribute('src');
        if (!img.dataset.srcOrig) img.dataset.srcOrig = orig;
        const low = addCdnParams(orig, { width: 1100, format: 'pjpg', quality: 60 });
        img.src = low;
      });
    }
    function restoreImages() {
      document.querySelectorAll('.tpl-product__media img').forEach(img => {
        if (img.dataset.srcOrig) img.src = img.dataset.srcOrig;
      });
    }

    // --- Printtioptimointityylit ---
    function ensurePrintOptimizationsStyle() {
      if (document.getElementById('tpl-print-optimizations')) return;
      const style = document.createElement('style');
      style.id = 'tpl-print-optimizations';
      style.textContent = `
        @media print {
          :root { -webkit-print-color-adjust: economy; print-color-adjust: economy; }          
          .tpl-page { box-shadow: none !important; border-color: #000 !important; }
          .tpl-product__media img { max-width: 1100px !important; height: auto !important; }
        }
      `;
      document.head.appendChild(style);
    }

    // ===== HARD OPTIMIZATION: pakota kuvat JPEG:ksi (canvas), poista taustat printissä =====
    const __printImgCache = new Map(); // Map<img, {src, srcset, blobUrl?}>

    async function compressImgElement(img, { maxWidth = 1100, quality = 0.58 } = {}) {
      if (!__printImgCache.has(img)) {
        __printImgCache.set(img, { src: img.src, srcset: img.srcset || "" });
      }
      img.srcset = "";

      const probe = new Image();
      probe.crossOrigin = "anonymous";
      const sourceUrl = img.currentSrc || img.src;

      try {
        await new Promise((resolve, reject) => {
          probe.onload = resolve;
          probe.onerror = reject;
          probe.src = sourceUrl;
        });

        const natW = probe.naturalWidth || maxWidth;
        const natH = probe.naturalHeight || Math.round(maxWidth * 0.75);
        const scale = Math.min(1, maxWidth / natW);
        const w = Math.max(1, Math.round(natW * scale));
        const h = Math.max(1, Math.round(natH * scale));

        if (natW <= maxWidth) return;

        const canvas = document.createElement("canvas");
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext("2d", { alpha: false });
        ctx.drawImage(probe, 0, 0, w, h);

        const dataUrl = canvas.toDataURL("image/jpeg", quality);
        const blob = await (await fetch(dataUrl)).blob();
        const blobUrl = URL.createObjectURL(blob);

        img.src = blobUrl;
        const rec = __printImgCache.get(img);
        rec.blobUrl = blobUrl;
      } catch {
        // CORS tms.: jätetään alkuperäinen source, mutta srcset on jo tyhjä
      }
    }

    async function preparePrintImagesHard() {
      const imgs = Array.from(document.querySelectorAll(".tpl-product__media img, .tpl-cover__logo img"));
      for (const img of imgs) {
        if (img.loading === "lazy") img.loading = "eager";
        // eslint-disable-next-line no-await-in-loop
        await compressImgElement(img, { maxWidth: 1100, quality: 0.58 });
      }
    }

    function restoreImagesHard() {
      __printImgCache.forEach((rec, img) => {
        try {
          if (rec.src) img.src = rec.src;
          img.srcset = rec.srcset || "";
          if (rec.blobUrl) URL.revokeObjectURL(rec.blobUrl);
        } catch {}
      });
      __printImgCache.clear();
    }

    // Taustat pois printissä (maksimikevennys)
    const __bgOriginals = new Map();
    function stripBackgroundsForPrint() {
      document.querySelectorAll(".tpl-cover, .tpl-back").forEach(el => {
        if (!__bgOriginals.has(el)) __bgOriginals.set(el, getComputedStyle(el).backgroundImage);
        el.style.backgroundImage = "";
      });
    }
    function restoreBackgroundsAfterPrint() {
      __bgOriginals.forEach((bg, el) => { el.style.backgroundImage = bg; });
      __bgOriginals.clear();
    }

    // --- Kytke tulostus-hookit ---
    if (!window.__tuotelistaPrintHooksBound) {
      window.addEventListener("beforeprint", async () => {
        ensurePrintOptimizationsStyle();
        stripBackgroundsForPrint();
        await preparePrintImagesHard();
      });
      window.addEventListener("afterprint", () => {
        restoreBackgroundsAfterPrint();
        restoreImagesHard();
      });
      window.__tuotelistaPrintHooksBound = true;
    }

    // ----- Tulostusnappi: tee samat optimoinnit manuaalisesti -----
    btnDownload?.addEventListener("click", async () => {
      try {
        if (btnDownload) btnDownload.disabled = true;
        ensurePrintOptimizationsStyle();
        // stripBackgroundsForPrint(); //
        await preparePrintImagesHard();
        window.print();
      } finally {
        // restoreBackgroundsAfterPrint(); //
        restoreImagesHard();
        if (btnDownload) btnDownload.disabled = false;
      }
    });

    // ------------------------------------------------------------------------

    const gid = (type, id) => `gid://shopify/${type}/${id}`;

    // --- KIELI: map localesta GraphQL LanguageCodeksi ---
    const languageCode = mapLocaleToLanguageCode(cfg.locale);

    const gql = async (query, variables) => {
      if (!cfg.token || !cfg.shop) {
        console.error("[Tuotelista] Puuttuva shop-osoite tai Storefront access token.");
        return { nodes: [] };
      }
      const endpoint = `https://${cfg.shop}/api/2024-10/graphql.json`;
      const body = JSON.stringify({ query, variables });
      const res = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": cfg.token
        },
        body
      });
      const text = await res.text();
      let json = {};
      try { json = JSON.parse(text); } catch (e) {
        console.error("[Tuotelista] GraphQL JSON parse error:", e, text);
        throw new Error("GraphQL parse error");
      }
      if (!res.ok) {
        console.error("[Tuotelista] Storefront API virhe:", res.status, res.statusText, json?.errors);
        throw new Error(`Storefront API virhe: ${res.status}`);
      }
      if (json.errors && json.errors.length) {
        console.warn("[Tuotelista] GraphQL errors:", json.errors);
        // Yritetään silti palauttaa mahdollinen osittainen data
      }
      return json.data || {};
    };

    const PRODUCT_QUERY = `
      query ProductsByIds($ids: [ID!]!, $language: LanguageCode)
      @inContext(language: $language) {
        nodes(ids: $ids) {
          ... on Product {
            id
            title
            description
            featuredImage { url altText }
            options { name values }
            variants(first: 100) {
              edges {
                node {
                  id
                  price { amount currencyCode }
                  availableForSale
                  selectedOptions { name value }
                }
              }
            }

            # Dimex / muut yksittäiset kentät
            dimex: metafield(namespace: "custom", key: "dimex_tuotenumero") { value }
            tekniset: metafield(namespace: "global", key: "tekniset_ominaisuudet_kuvaus") { value }
            materiaali: metafield(namespace: "global", key: "materiaali") { value }

            # Standardit (single line text)
            standardit: metafield(namespace: "global", key: "standardit") { value }

            # --- TARKENNEKENTÄT ---
            en_342:        metafield(namespace: "global", key: "en_342") { value }
            en_1149_5:     metafield(namespace: "global", key: "en_1149_5") { value }
            en_407:        metafield(namespace: "global", key: "en_407") { value }
            EN_511:        metafield(namespace: "global", key: "EN_511") { value }
            en_388_a1:     metafield(namespace: "global", key: "en_388_a1") { value }
            en_388:        metafield(namespace: "global", key: "en_388") { value }
            en_343:        metafield(namespace: "global", key: "en_343") { value }
            en_iso_11611:  metafield(namespace: "global", key: "en_iso_11611") { value }
            en_iso_11612:  metafield(namespace: "global", key: "en_iso_11612") { value }
            en_61482_2:    metafield(namespace: "global", key: "en_61482_2") { value }
            en_20471:      metafield(namespace: "global", key: "en_20471") { value }
            en_13034:      metafield(namespace: "global", key: "en_13034") { value }
          }
        }
      }
    `;

    // ----- Lomakekuuntelijat -----
    [fTitle, fCName, fCAddr, fCTel, fCEmail, fCWWW, fVat255].forEach((inp) => {
      if (!inp) return;
      inp.addEventListener("input", () => {
        state.form = {
          title: (fTitle && fTitle.value.trim()) || "",
          cname: (fCName && fCName.value.trim()) || "",
          caddr: (fCAddr && fCAddr.value.trim()) || "",
          ctel: (fCTel && fCTel.value.trim()) || "",
          cemail: (fCEmail && fCEmail.value.trim()) || "",
          cwww: (fCWWW && fCWWW.value.trim()) || "",
          vat255: !!(fVat255 && fVat255.checked)
        };
        saveState(state);
        applyCoverAndBack();
        updateAllPricesVatText();
      });
      inp.addEventListener("change", () => inp.dispatchEvent(new Event("input")));
    });

    // ----- Paneelin helpers -----
    function showRemovedPanel() {
      if (!removedPanel) return;
      renderRemovedPanel();
      removedPanel.removeAttribute("hidden");
      btnRemovedToggle?.setAttribute("aria-expanded", "true");
    }
    function hideRemovedPanel() {
      if (!removedPanel) return;
      removedPanel.setAttribute("hidden", "");
      btnRemovedToggle?.setAttribute("aria-expanded", "false");
    }

    btnRemovedToggle?.addEventListener("click", () => {
      if (removedPanel?.hasAttribute("hidden")) showRemovedPanel();
      else hideRemovedPanel();
    });
    btnRemovedClose?.addEventListener("click", () => hideRemovedPanel());
    btnRemovedRestoreAll?.addEventListener("click", () => { restoreAll(); hideRemovedPanel(); });

    // Sulje Escillä
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && removedPanel && !removedPanel.hasAttribute("hidden")) {
        hideRemovedPanel();
      }
    });

    // ----- Haku ja render -----
    run().catch((e) => {
      console.error("[Tuotelista] Virhe run():", e);
      renderEmpty(getI18n('load_failed', "Tietojen lataus epäonnistui."));
    });

    // ====== Funktiot ======
    function loadState() { try { return JSON.parse(localStorage.getItem(LS_KEY) || ""); } catch { return null; } }
    function saveState(s) { try { localStorage.setItem(LS_KEY, JSON.stringify(s)); } catch {} }

    function ensurePrintOnlyHideStyle() {
      if (document.getElementById("tpl-print-hide-style")) return;
      const style = document.createElement("style");
      style.id = "tpl-print-hide-style";
      style.textContent = "@media print{.tpl-hide-in-print{display:none!important}.is-removed{display:none!important}}";
      document.head.appendChild(style);
    }

    // Uusi: €-suffixin UI-tyylit
    function ensureSuffixStyles() {
      if (document.getElementById("tpl-input-suffix-style")) return;
      const style = document.createElement("style");
      style.id = "tpl-input-suffix-style";
      style.textContent = `
        .tpl-input-suffix{position:relative;display:inline-block;width:100%;}
        .tpl-input-suffix input{padding-right:2.2em;}
        .tpl-input-suffix .suffix{position:absolute;right:1.6rem;top:50%;transform:translateY(-50%);pointer-events:none;opacity:.7;}
      `;
      document.head.appendChild(style);
    }

    function applyCoverAndBack() {
      if (coverTitleEl) coverTitleEl.textContent = (fTitle && fTitle.value.trim()) || "";
      if (backCompanyEl) {
        const parts = [
          fCName && fCName.value.trim(),
          fCAddr && fCAddr.value.trim(),
          fCTel && fCTel.value.trim(),
          fCEmail && fCEmail.value.trim(),
          fCWWW && fCWWW.value.trim()
        ].filter(Boolean);
        backCompanyEl.innerHTML = parts.length ? `<p>${parts.join("<br>")}</p>` : "";
      }
    }

    function renderEmpty(msg) {
      const el = document.createElement("div");
      el.className = "tpl-page";
      el.innerHTML = `<div class="tpl-empty">${msg || (getI18n('empty_cart', "Ostoskorisi on tyhjä. Lisää tuotteita ja palaa tälle sivulle."))}</div>`;
      productsContainer.appendChild(el);
      updateClearVisibility();
      updateRemovedUI();
      renderRemovedPanel();
    }

    // --- ALV-laskenta ja merkkijonot ---
    function priceText(baseAmount, currency) {
      const amount = parseFloat(baseAmount || 0);
      const net = cfg.taxesIncluded ? (amount / 1.255) : amount; // aina netto
      const showGross = !!(state.form?.vat255);
      const display = showGross ? (net * 1.255) : net;

      const formatted = money(display, currency);
      if (showGross) {
        const suffix = getI18n('vat255', '(sis. ALV 25,5 %)'); // "(incl. VAT 25.5%)"
        return `${formatted} ${suffix}`;
      } else {
        const suffix = getI18n('vat0', '(ALV 0 %)'); // "(VAT 0%)"
        return `${formatted} ${suffix}`;
      }
    }

    function updateAllPricesVatText() {
      const boxes = document.querySelectorAll("[data-price-box]");
      boxes.forEach((box) => {
        const base = box.dataset.baseAmount;
        const currency = box.dataset.baseCurrency;
        const custom = box.dataset.customText || "";
        if (!base || custom) return; // käyttäjän oma teksti voittaa
        box.textContent = priceText(base, currency);
      });
    }

    // Sertifikaattien parsinta
    function parseStandardit(raw) {
      if (!raw) return [];
      let s = typeof raw === "string" ? raw.trim() : String(raw).trim();
      if (s.startsWith("[") && s.endsWith("]")) {
        try {
          const arr = JSON.parse(s);
          if (Array.isArray(arr)) return arr.map(x => String(x).trim()).filter(Boolean);
        } catch {}
      }
      return s
        .replace(/^\[|\]$/g, "")
        .split(/[,;\n]/)
        .map(t => t.replace(/^["']|["']$/g, "").trim())
        .filter(Boolean);
    }

    function getRemovedPids() {
      const all = Object.keys(state.removed || {}).filter(pid => !!state.removed[pid]);
      return all.filter(pid => cartPidSet.has(pid));
    }

    function syncRemovedWithCart() {
      let changed = false;
      Object.keys(state.removed || {}).forEach(pid => {
        if (state.removed[pid] && !cartPidSet.has(pid)) {
          delete state.removed[pid];
          changed = true;
        }
      });
      if (changed) saveState(state);
    }

    function updateRemovedUI() {
      const count = getRemovedPids().length;
      if (btnRemovedToggle) {
        const label = getI18n('removed', 'Poistetut');
        btnRemovedToggle.textContent = `${label} (${count})`;
        btnRemovedToggle.style.display = count === 0 ? "none" : "";
        if (count === 0) btnRemovedToggle.setAttribute("aria-expanded", "false");
      }
      if (removedPanel && count === 0) removedPanel.setAttribute("hidden", "");
    }

    function showSnackbar(message, actionLabel, onAction) {
      if (!snackbar) return;
      snackbar.innerHTML = `
        <div class="tpl-snackbar__inner">
          <span>${message}</span>
          ${actionLabel ? `<button type="button" class="tpl-snackbar__action">${actionLabel}</button>` : ""}
        </div>
      `;
      snackbar.classList.add("is-visible");
      const actionBtn = snackbar.querySelector(".tpl-snackbar__action");
      let hideTimer = setTimeout(hide, 6000);
      function hide() {
        snackbar.classList.remove("is-visible");
        snackbar.innerHTML = "";
      }
      actionBtn?.addEventListener("click", () => {
        clearTimeout(hideTimer);
        hide();
        onAction && onAction();
      });
    }

    function renderRemovedPanel() {
      if (!removedList) return;
      const pids = getRemovedPids();
      if (!pids.length) {
        removedList.innerHTML = `<div class="tpl-removed-empty">${getI18n('no_removed', 'Ei poistettuja tuotteita.')}</div>`;
        return;
      }
      removedList.innerHTML = pids.map((pid) => {
        const meta = state.products[pid]?.meta || {};
        const title = meta.title || "Tuote";
        const thumb = meta.image ? `<img src="${imageUrl(meta.image, 200)}" alt="">` : "";
        const restoreLabel = getI18n('restore', 'Palauta');
        return `
          <div class="tpl-removed-item" data-pid="${pid}">
            <div class="tpl-removed-thumb">${thumb}</div>
            <div class="tpl-removed-title">${title}</div>
            <div class="tpl-removed-actions">
              <button type="button" class="tpl-btn tpl-btn--secondary tpl-restore-one">${restoreLabel}</button>
            </div>
          </div>
        `;
      }).join("");
      removedList.querySelectorAll(".tpl-restore-one").forEach((btn) => {
        btn.addEventListener("click", () => {
          const pid = btn.closest(".tpl-removed-item")?.dataset.pid;
          if (!pid) return;
          restoreOne(pid);
        });
      });
    }

    function restoreOne(pid) {
      delete state.removed[pid];
      saveState(state);
      const el = document.querySelector(`.tpl-page[data-pid="${CSS.escape(pid)}"]`);
      el?.classList.remove("is-removed");
      updateRemovedUI();
      renderRemovedPanel();
      updateClearVisibility();
    }

    function restoreAll() {
      getRemovedPids().forEach(pid => { delete state.removed[pid]; });
      saveState(state);
      document.querySelectorAll(".tpl-page.is-removed").forEach((el) => el.classList.remove("is-removed"));
      updateRemovedUI();
      renderRemovedPanel();
      updateClearVisibility();
    }

    // ===== : €-suffix =====
    function decoratePriceText(raw) {
      const t = (raw || "").trim();
      if (!t) return "";
      if (/[€$£]|(?:\b(?:eur|usd|sek|nok|dkk|pln|czk|gbp|jpy|cny|aud|cad)\b)/i.test(t)) return t;
      return `${t} €`;
    }

    function productControls(p, pageEl, refs) {
      const pid = p.id;
      const st = state.products[pid] || {};

      const controls = document.createElement("div");
      controls.className = "tpl-controls";
      controls.innerHTML = `
        <div>
          <label class="tpl-field">
            <span data-i18n="notes_label">${getI18n('notes_label', 'Product notes')}</span>
            <textarea class="ctl-notes" placeholder="${getI18n('notes_placeholder', 'Add any notes (shown below product details)')}">${st.notes || ""}</textarea>
          </label>
          <div class="row">
            <label class="tpl-check">
              <input type="checkbox" class="ctl-hide-notes" ${st.hideNotes ? "checked" : ""}>
              <span>${getI18n('hide_notes_in_pdf', 'Hide notes in PDF')}</span>
            </label>
          </div>
        </div>
        <div>
          <label class="tpl-field">
            <span>${getI18n('price_mark_label', 'Price note')}</span>
            <div class="tpl-input-suffix">
              <input type="text" class="ctl-price-text" placeholder="${getI18n('price_mark_placeholder', 'e.g. 39.90')}" value="">
              <span class="suffix">€</span>
            </div>
          </label>
          <div class="row">
            <label class="tpl-check">
              <input type="checkbox" class="ctl-hide-price" ${st.hidePrice ? "checked" : ""}>
              <span>${getI18n('hide_price_in_pdf', 'Hide price in PDF')}</span>
            </label>
          </div>
          <div class="row">
            <button type="button" class="btn-mini danger ctl-remove">${getI18n('remove_from_list', 'Remove this product from the list')}</button>
          </div>
        </div>
      `;
      pageEl.appendChild(controls);

      const infoEl = pageEl.querySelector(".tpl-product__info");
      const elNotes = controls.querySelector(".ctl-notes");
      const elHideNotes = controls.querySelector(".ctl-hide-notes");
      const elPriceText = controls.querySelector(".ctl-price-text");
      const elHidePrice = controls.querySelector(".ctl-hide-price");
      const btnRemove = controls.querySelector(".ctl-remove");

      // Huomiot
      let notesWrapper = pageEl.querySelector(".tpl-notes");
      function createNotesIfMissing() {
        if (notesWrapper) return;
        notesWrapper = document.createElement("div");
        notesWrapper.className = "tpl-block tpl-notes";
        const h = getI18n('notes_title', 'Product notes');
        notesWrapper.innerHTML = `<h4>${h}</h4><div class="tpl-notes-text"></div>`;
        infoEl.appendChild(notesWrapper);
      }
      function removeNotesIfEmpty() {
        if (!notesWrapper) return;
        const box = notesWrapper.querySelector(".tpl-notes-text");
        const isEmpty = !box || !box.textContent || box.textContent.trim() === "";
        if (isEmpty) { notesWrapper.remove(); notesWrapper = null; }
      }
      function setNotesText(text) {
        const t = (text || "").trim();
        if (!t) { removeNotesIfEmpty(); return; }
        createNotesIfMissing();
        notesWrapper.querySelector(".tpl-notes-text").textContent = t;
        togglePrintHide(notesWrapper, !!(elHideNotes && elHideNotes.checked));
      }

      setNotesText(st.notes || "");
      elNotes.addEventListener("input", () => {
        const v = elNotes.value || "";
        setNotesText(v);
        state.products[pid] = { ...state.products[pid], notes: v };
        saveState(state);
      });
      elHideNotes.addEventListener("change", () => {
        const hide = elHideNotes.checked;
        if (notesWrapper) togglePrintHide(notesWrapper, hide);
        state.products[pid] = { ...state.products[pid], hideNotes: hide };
        saveState(state);
      });

      // Hintamerkintä
      const rawInitial = st.priceTextRaw || "";
      elPriceText.value = rawInitial;
      if (rawInitial) {
        const decorated = decoratePriceText(rawInitial);
        refs.priceBox.textContent = decorated;
        refs.priceBox.dataset.customText = decorated;
      }
      togglePrintHide(refs.priceBox, !!st.hidePrice);

      elPriceText.addEventListener("input", () => {
        const raw = elPriceText.value;
        const decorated = decoratePriceText(raw);
        if (decorated) {
          refs.priceBox.textContent = decorated;
          refs.priceBox.dataset.customText = decorated;
        } else if (refs._basePrice) {
          refs.priceBox.textContent = priceText(refs._basePrice.amount, refs._basePrice.currencyCode);
          refs.priceBox.dataset.customText = "";
        } else {
          refs.priceBox.textContent = "";
          refs.priceBox.dataset.customText = "";
        }
        state.products[pid] = { ...state.products[pid], priceTextRaw: raw };
        saveState(state);
      });

      elHidePrice.addEventListener("change", () => {
        const hide = elHidePrice.checked;
        togglePrintHide(refs.priceBox, hide);
        state.products[pid] = { ...state.products[pid], hidePrice: hide };
        saveState(state);
      });

      // Poisto
      btnRemove.addEventListener("click", () => {
        pageEl.classList.add("is-removed");
        state.removed[pid] = true;
        saveState(state);
        syncRemovedWithCart();
        updateRemovedUI();
        renderRemovedPanel();
        updateClearVisibility();
        showSnackbar(getI18n('removed_item', "Product was removed from the list."), getI18n('undo', "Undo"), () => restoreOne(pid));
      });
    }

    function togglePrintHide(el, shouldHideInPrint) {
      if (!el) return;
      el.classList.toggle("tpl-hide-in-print", !!shouldHideInPrint);
    }

    // --- Apuri: pilko taulukko eriin ---
    function chunk(arr, size) {
      const out = [];
      for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
      return out;
    }

    async function run() {
      const cartRes = await fetch("/cart.js", { credentials: "same-origin" });
      if (!cartRes.ok) throw new Error(`Cart virhe: ${cartRes.status}`);
      const cart = await cartRes.json();
      const items = cart.items || [];

      const currentIds = items.map(i => gid("Product", i.product_id));
      cartPidSet = new Set(currentIds);

      if (!items.length) {
        state.removed = {};
        saveState(state);
        updateRemovedUI();
        renderRemovedPanel();
        renderEmpty(getI18n('empty_cart', "Ostoskorisi on tyhjä. Lisää tuotteita ja palaa tälle sivulle."));
        return;
      }

      // VANHIN -> UUSIN
      const productIds = currentIds.slice().reverse();

      syncRemovedWithCart();

      // --- Hae erissä (50 / batch) ---
      const batches = chunk(productIds, 50);
      const allNodesById = new Map();

      for (let bi = 0; bi < batches.length; bi++) {
        const ids = batches[bi];
        try {
          const data = await gql(PRODUCT_QUERY, { ids, language: languageCode });
          const nodesRaw = (data && Array.isArray(data.nodes)) ? data.nodes : [];
          nodesRaw.forEach(n => { if (n && n.id) allNodesById.set(n.id, n); });
          // Loggaa puuttuvat ID:t debuggaukseen
          const missing = ids.filter(id => !allNodesById.has(id));
          if (missing.length) {
            console.warn(`[Tuotelista] Batch ${bi+1}/${batches.length} – puuttuvia tuotteita:`, missing);
          }
        } catch (e) {
          console.error(`[Tuotelista] Batch ${bi+1}/${batches.length} epäonnistui:`, e);
          // Jatka seuraavaan batchiin, älä kaada koko listaa
          continue;
        }
      }

      const nodesInCartOrder = productIds.map(id => allNodesById.get(id)).filter(Boolean);

      if (!nodesInCartOrder.length) {
        console.warn("[Tuotelista] Tuotteita ei saatu haettua. productIds:", productIds);
        renderEmpty(getI18n('load_failed', 'Tuotetietojen haku epäonnistui.'));
        return;
      }

      // Renderöi tuotteet; yksittäisen renderöinnin virhe ei pysäytä
      for (const p of nodesInCartOrder) {
        try {
          // eslint-disable-next-line no-await-in-loop
          await renderProductPageAsync(p);
        } catch (e) {
          console.error("[Tuotelista] renderProductPageAsync epäonnistui id: ", p?.id, e);
        }
      }

      updateRemovedUI();
      renderRemovedPanel();
    }

    async function renderProductPageAsync(p) {
      const variants = (p.variants?.edges || []).map((e) => e.node);
      const prices = variants.map((v) => parseFloat(v.price?.amount || "0")).filter((n) => n > 0);
      const minPrice = prices.length ? Math.min(...prices) : null;
      const currency = variants[0]?.price?.currencyCode || "EUR";

      const colors = byOptionName(p.options || [], COLOR_NAMES);
      const sizes  = sizesFromVariants(variants, SIZE_NAMES);

      const tuotenumero = p.dimex?.value || null;
      const tekniset    = p.tekniset?.value || "";
      const materiaali  = p.materiaali?.value || "";

      // --- Sertifikaatit tarkenteineen ---
      const stdList = parseStandardit(p.standardit?.value);

      function pickMetaKeyFromLabel(label) {
        const L = String(label).toUpperCase();

        // Salli sekä "EN ISO 11611" että "EN 11611" (samoin 11612).
        if (/EN\s+(?:ISO\s+)?11611/.test(L)) return 'en_iso_11611';
        if (/EN\s+(?:ISO\s+)?11612/.test(L)) return 'en_iso_11612';

        if (L.includes('EN 1149-5')) return 'en_1149_5';
        if (L.includes('EN 61482-2')) return 'en_61482_2';
        if (L.includes('EN 20471'))   return 'en_20471';
        if (L.includes('EN 13034'))   return 'en_13034';
        if (L.includes('EN 0342') || L.includes('EN 342')) return 'en_342';
        if (L.includes('EN 0343') || L.includes('EN 343')) return 'en_343';
        if (L.includes('EN 0407') || L.includes('EN 407')) return 'en_407';
        if (L.includes('EN 0511') || L.includes('EN 511')) return 'EN_511';
        if (L.includes('EN 0388') || L.includes('EN 388')) return 'en_388';
        if (L.includes('EN 388') && /(^|[^A-Z0-9])A1([^A-Z0-9]|$)/i.test(L)) return 'en_388_a1';
        return null;
      }


      function detailFromKey(key) {
        if (!key) return '';
        return (p[key]?.value || '').trim();
      }

      const certs = stdList.map((label) => {
        const key = pickMetaKeyFromLabel(label);
        const detail = detailFromKey(key);
        return detail ? `${label} — ${detail}` : label;
      });

      const certsHtml = certs.length
        ? `<ul class="tpl-list">${certs.map(li => `<li>${li}</li>`).join("")}</ul>`
        : "";

      const img = p.featuredImage
        ? `<img src="${imageUrl(p.featuredImage.url)}" alt="${(p.featuredImage.altText || p.title).replace(/"/g, '&quot;')}">`
        : "";

      const colorsHtml = colors.length ? `<div class="tpl-tags">${colors.map(c => `<span class="tpl-tag">${c}</span>`).join("")}</div>` : "";
      const sizesHtml  = sizes.length  ? `<div class="tpl-tags">${sizes.map(s => `<span class="tpl-tag">${s}</span>`).join("")}</div>`  : "";

      const basePrice = (minPrice && currency) ? { amount: minPrice, currencyCode: currency } : null;
      const priceHtml = basePrice
        ? `<div class="tpl-price" data-price-box data-base-amount="${basePrice.amount}" data-base-currency="${basePrice.currencyCode}">
             ${priceText(basePrice.amount, basePrice.currencyCode)}
           </div>`
        : "";

      const pageEl = document.createElement("div");
      pageEl.className = "tpl-page";
      pageEl.dataset.pid = p.id;
      pageEl.innerHTML = `
        <div class="tpl-product">
          <div class="tpl-product__media">${img}</div>
          <div class="tpl-product__info">
            <div class="tpl-product__head">
              ${tuotenumero ? `<div class="tpl-sku">${tuotenumero}</div>` : ``}
              <div class="tpl-title">${p.title}</div>
              ${priceHtml}
            </div>

            ${p.description ? `<div class="tpl-block"><h4>${getI18n('description', 'Description')}</h4><div class="tpl-desc">${p.description}</div></div>` : ``}
            ${certsHtml   ? `<div class="tpl-block"><h4>${getI18n('certificates', 'Certificates')}</h4>${certsHtml}</div>` : ``}
            ${colorsHtml  ? `<div class="tpl-block"><h4>${getI18n('colors', 'Colors')}</h4>${colorsHtml}</div>` : ``}
            ${sizesHtml   ? `<div class="tpl-block"><h4>${getI18n('sizes', 'Sizes')}</h4>${sizesHtml}</div>` : ``}
            ${materiaali  ? `<div class="tpl-block"><h4>${getI18n('materials', 'Materials')}</h4><div>${materiaali}</div></div>` : ``}
            ${tekniset    ? `<div class="tpl-block"><h4>${getI18n('additional', 'Additional information')}</h4><div>${tekniset}</div></div>` : ``}
            <!-- Huom: Huomiot-lohkoa ei luoda tässä; se luodaan JS:llä vain, jos on tekstiä -->
          </div>
        </div>
      `;
      productsContainer.appendChild(pageEl);

      if (state.removed[p.id]) pageEl.classList.add("is-removed");

      const priceBox = pageEl.querySelector("[data-price-box]");

      state.products[p.id] = {
        ...(state.products[p.id] || {}),
        meta: { title: p.title, image: p.featuredImage?.url || "" }
      };
      saveState(state);

      productControls(p, pageEl, { priceBox, _basePrice: basePrice });
      updateRemovedUI();
      updateClearVisibility();
    }

    function updateClearVisibility() {
      const visibleCount = document.querySelectorAll('.tpl-page[data-pid]:not(.is-removed)').length;
      if (btnClear) btnClear.style.display = visibleCount === 0 ? 'none' : '';
    }

    function mapLocaleToLanguageCode(locale) {
      const lc = String(locale || "").toLowerCase();
      if (lc.startsWith("fi")) return "FI";
      if (lc.startsWith("en")) return "EN";
      if (lc.startsWith("de")) return "DE";
      if (lc.startsWith("et")) return "ET";
      return null;
    }

    function formatMoneyRight(amount, currencyCode, locale) {
      const n = Number.parseFloat(amount || 0);
      const parts = new Intl.NumberFormat(locale, { style: "currency", currency: currencyCode || "EUR" }).formatToParts(n);
      const numberPart = parts.filter(p => p.type !== "currency").map(p => p.value).join("");
      const symbolPart = (parts.find(p => p.type === "currency")?.value) || currencyCode || "€";
      return `${numberPart} ${symbolPart}`;
    }
  }
})();
